import React from "react";
import styles from "./BottomSheet.module.scss";
import { useEffect } from "react";

import { useOnClickOutside } from "hooks/useOnClickOutside";
interface IProps {
  children: React.ReactNode;
  bottomSheetOpen: boolean;
  onCloseBottomSheet: () => void;
}
export default function BottomSheet({ children, bottomSheetOpen, onCloseBottomSheet }: IProps) {
  const onClickOutsideRef = useOnClickOutside(onCloseBottomSheet);

  useEffect(() => {
    return () => {
      onCloseBottomSheet();
    };
  }, []);

  return bottomSheetOpen ? (
    <>
      <section className={styles.overlay} data-active={bottomSheetOpen} />
      <section className={styles.modalWrapper} ref={onClickOutsideRef} data-active={bottomSheetOpen}>
        <div className={styles.modalInner}>{children}</div>
      </section>
    </>
  ) : null;
}
